<template>
    <form action="/">
        <van-search
            v-model="searchValue"
            show-action
            shape="round"
            :left-icon = 'searchIcon'
            placeholder="请输入搜索关键词"
            @search="onSearch"
            @cancel="onCancel"
        />
    </form>
</template>

<script>
export default {
    props: {
        searchVal: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            searchIcon: require('../../../../assets/img/b2b/search.png'),
            searchValue: ''
        }
    },
    methods: {
        onSearch () {
            this.$emit('searchVal', this.searchValue)
        },
        onCancel () {
            this.$emit('goBack')
        }
    },
    mounted () {
        this.searchValue = this.searchVal
    }
}
</script>

<style lang='scss' scoped>
    /deep/ .van-search__content{
        background-color: #ebebeb;
    }
    /deep/ .van-search .van-cell{
        line-height: 64px;
        height: 64px;
        padding-top: 10px;
    }
    /deep/ .van-search__content--round{
        border-radius: 64px;
    }
    /deep/ .van-search{
        padding: 12px 4px 12px 24px;
    }
    /deep/ .van-search__action {
        padding: 0 20px;
        color: #FF7A45;
    }
    /deep/ .van-field__left-icon .van-icon {
        font-size: 32px;
        top: -8px;
        right: -16px;
        width: 58px;
    }
    /deep/ .van-search__action {
        font-size: 28px;
    }
</style>